import React from 'react';

import { Section } from '..';
import etr from './assets/ESCAPETHEROOMers_logo_dark.png';
import style from './LoveMessage.module.less';

interface ETRSectionProps {
  alternate?: boolean;
}

export const ETRSection: React.FC<ETRSectionProps> = ({ alternate }) => (
  <Section className={style.loveSection} alternate={alternate}>
    <div className={style.content}>
      <h1 className={style.header}>In collaboration with</h1>

      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a
        href="https://www.escapetheroomers.com/"
        target="_blank"
        className={style.etrLink}
      >
        <img src={etr} alt="ESCAPETHEROOMers Logo" className={style.etr} />
      </a>
      <p>
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        The Box was created in collaboration with <a href="https://www.escapetheroomers.com" target="_blank">ESCAPETHEROOMers</a>
        {' '}- The ONLY review site for escape room & at home games that provides daily content in blog and vlog formats.
      </p>
    </div>
  </Section>
);
